export default __webpack_public_path__ + "static/media/404.7c7d8be2.svg";